import { atom } from 'recoil'
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist({
    key: '@sgiopentreatment', // this key is using to store data in local storage
    storage: localStorage, // configurate which stroage will be used to store the data
})

const openTreatment = atom({
    key: 'openTreatment', // unique ID (with respect to other atoms/selectors)
    default: false, // default value (aka initial value)
    effects_UNSTABLE: [persistAtom],
});

export const openTreatmentStatusState = atom({
    key: 'openTreatmentStatusState', // unique ID (with respect to other atoms/selectors)
    default: false, // default value (aka initial value)
    effects_UNSTABLE: [persistAtom],
});

export default openTreatment